import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Fzf + emoji is fun!😆...`}</p>
    <h1>{`Vim Fzf`}</h1>
    <p>{`A powerful tool that you should know if you use command lines. I assume you know Fzf well and have it working with Vim.`}</p>
    <h1>{`Vim Script`}</h1>
    <p>{`We need a plugin from the same author of Fzf: `}<a parentName="p" {...{
        "href": "https://github.com/junegunn/vim-emoji"
      }}>{`Vim-Emoji`}</a>{`. However, appreantly author didn't bother to tell the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fzf`}</code>{` flavor of this plugin. So here I am:`}</p>
    <p>{`You need extra scripts to load all emojis from plugin and dump it to fzf so that you can find your emoji with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fzf`}</code>{`!`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "vim"
    }}><pre parentName="div" {...{
        "className": "language-vim"
      }}><code parentName="pre" {...{
          "className": "language-vim"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` s`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`getemoji`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` keys `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` emoji#`}<span parentName="code" {...{
            "className": "token function"
          }}>{`list`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` retval `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`e`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` keys
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` v `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` emoji#`}<span parentName="code" {...{
            "className": "token function"
          }}>{`for`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`e`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`call`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`retval`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`e`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'='`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfor`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` retval
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` s`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`addemoji`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`line`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` arr `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`split`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`a`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`line`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'='`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    execute `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"normal! a"`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span>{` arr`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"\\<Esc>"`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span>{`

command`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`nargs`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` FzfEmoji `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`call`}</span>{` fzf#`}<span parentName="code" {...{
            "className": "token function"
          }}>{`run`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
            \\ `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'source'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`sid`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`getemoji`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
            \\ `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'sink'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'<sid>addemoji'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
            \\ `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'down'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`    `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'50%'`}</span>{`
            \\`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}</code></pre></div>
    <p>{`Now go bind `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`FzfEmoji`}</code>{` and have fun!`}</p>
    <p>{`For more fzf vim script and plugins, see my fzf `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/neovim/nvim/config/functions.vimrc#L44-L117"
      }}>{`collections`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      